import PropTypes from "prop-types";
import { FaRegHandshake } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CardNotificacaoBase from "./CardNotificacaoBase";

/**
 * Notificação de indicação de profissional — na criação e no aceite do termo.
 *
 * Sem este card a notificação caía no genérico ("Você tem uma nova notificação"), que não diz
 * quem foi indicado nem por quem. O escopo pede que a operação seja informada sobre o
 * preenchimento e tenha acesso aos dados, então o cartão leva direto para a fila.
 */
const CardIndicacaoProfissional = ({ notif }) => {
    const navigate = useNavigate();
    const dados = notif.dados || {};
    const aceite = notif.tipo === "indicacao_termo_aceito";

    const titulo = aceite
        ? "Termo da indicação aceito"
        : "Nova indicação de profissional de saúde";

    const descricao = [
        dados.nome_indicado,
        dados.conselho && `(${dados.conselho})`,
        dados.medico_nome && `· indicado por ${dados.medico_nome}`,
        dados.programa_nome && `· ${dados.programa_nome}`,
    ].filter(Boolean).join(" ");

    // a API já entrega "dd/mm/aaaa hh:mm"; reinterpretar isso com `new Date` dava Invalid Date
    const dataDisplay = !notif.data_criacao
        ? "-"
        : (String(notif.data_criacao).includes("/")
            ? notif.data_criacao
            : new Date(notif.data_criacao).toLocaleString("pt-BR"));

    const cor = aceite ? "success" : "primary";

    return (
        <CardNotificacaoBase
            notificacao={notif}
            icon={<FaRegHandshake />}
            color={cor}
            text={`text-${cor}`}
            label={aceite ? "Termo aceito" : "Indicação"}
            titulo={titulo}
            descricao={descricao || "Indicação de profissional de saúde"}
            dataFormatada={dataDisplay}
            onClick={() => navigate("/indicacoes-recebidas")}
        />
    );
};

CardIndicacaoProfissional.propTypes = {
    notif: PropTypes.object.isRequired,
};

export default CardIndicacaoProfissional;
